export default "__VITE_ASSET__DV8zg2UX__"